import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
    paper: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
        width: '100%'
    },
    gridTitle: {
        marginBottom: theme.spacing(2),
    },
    button: {
        float: 'right'
    }
}));

export default useStyles;